export default __webpack_public_path__ + "static/media/digital-store-image-02.756dbd73.png";